import {request, serviceUrl} from "@/utils/request";

// 告警配置列表分页
export function listByPage(current = null,
                           size = null,
                           groupCode = null,
                           deviceCategoryId =null,
                           levelId = null,
                           gatewaySn = null,
                           deviceId = null,
                           pointId = null) {
  return request({
    url: serviceUrl.deviceService + '/alarm/setting/listByPage',
    params: {
      current,
      size,
      groupCode,
      deviceCategoryId,
      levelId,
      gatewaySn,
      deviceId,
      pointId,
    }
  })
}

// 删除告警配置
export function deleteSetting(data) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/setting/delete',
    params: data
  })
}

// 更新告警配置
export function updateSetting(alarmSetting) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/setting/update',
    data: alarmSetting
  })
}

// 新增告警配置
export function addSetting(alarmSetting) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/setting/addAlarmSetting',
    data: alarmSetting
  })
}


// 删除告警配置
export function countByLevelId(levelId) {
  return request({
    url: serviceUrl.deviceService + '/alarm/setting/countByLevelId',
    params: {levelId}
  })
}
